export default __webpack_public_path__ + "static/media/chat.5f932306.svg";